"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _redux = require("redux");
var _combineReducers = _interopRequireDefault(require("./scratch-paint/playground/reducers/combine-reducers"));
var _intl = require("./scratch-paint/playground/reducers/intl.js");
var _lodash = _interopRequireDefault(require("lodash.bindall"));
var _react = _interopRequireDefault(require("react"));
var _paintEditor = _interopRequireDefault(require("./scratch-paint/containers/paint-editor"));
var _wrapperModule = _interopRequireDefault(require("../wrapper.module.css"));
var _reactRedux = require("react-redux");
require("./App.css");
var _view = require("./scratch-paint/helper/view");
var _paper = _interopRequireDefault(require("@scratch/paper"));
var _layer = require("./scratch-paint/helper/layer");
var _math = require("./scratch-paint/helper/math");
var store = (0, _redux.createStore)(_combineReducers.default, _intl.intlInitialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
var SVGEditor = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SVGEditor, _React$Component);
  var _super = (0, _createSuper2.default)(SVGEditor);
  function SVGEditor(props) {
    var _this;
    (0, _classCallCheck2.default)(this, SVGEditor);
    _this = _super.call(this, props);
    (0, _lodash.default)((0, _assertThisInitialized2.default)(_this), ["handleUpdateName", "handleUpdateImage", "onUploadImage", "downloadImage", "b64toByteArray", "handleAlertMessage", "handleBack", "onSave", "handleSubmitToAiTool", "dataToFile"]);
    _this.id = 0;
    _this.state = {
      name: _this.props.name,
      image: _this.props.image,
      imageFormat: _this.props.type,
      rotationCenterX: 500,
      rotationCenterY: 100,
      imageId: _this.props.imageId,
      localImage: null,
      showDetectSeatButton: _this.props.showAutoDetectSeatButton
    };
    _this.reusableCanvas = document.createElement("canvas");
    return _this;
  }
  (0, _createClass2.default)(SVGEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.imageId !== this.props.imageId) {
        this.setState({
          name: this.props.name,
          image: this.props.image,
          imageFormat: this.props.type,
          rotationCenterX: 500,
          rotationCenterY: 100,
          imageId: this.props.imageId,
          localImage: null,
          showDetectSeatButton: this.props.showAutoDetectSeatButton
        });
      }
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      this.props.handleBack();
    }
  }, {
    key: "handleUpdateName",
    value: function handleUpdateName(val) {
      this.setState({
        name: val
      });
    }
  }, {
    key: "handleAlertMessage",
    value: function handleAlertMessage(msg) {
      this.props.handleAlertMessage(msg);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var topScroll = window.pageYOffset || document.documentElement.scrollTop;
      var leftScroll = window.pageXOffset || document.documentElement.scrollLeft;
      window.scrollTo(topScroll, leftScroll);
    }
  }, {
    key: "handleUpdateImage",
    value: function handleUpdateImage(isVector, image, rotationCenterX, rotationCenterY) {
      this.setState({
        imageFormat: isVector ? "svg" : "png"
      });
      if (!isVector) {}
      if (isVector) {
        this.setState({
          image: image,
          rotationCenterX: rotationCenterX,
          rotationCenterY: rotationCenterY
        });
      } else {
        this.reusableCanvas.width = image.width;
        this.reusableCanvas.height = image.height;
        var context = this.reusableCanvas.getContext("2d");
        context.putImageData(image, 0, 0);
        this.setState({
          image: this.reusableCanvas.toDataURL("image/png"),
          rotationCenterX: rotationCenterX,
          rotationCenterY: rotationCenterY
        });
      }
    }
  }, {
    key: "onUploadImage",
    value: function onUploadImage(event) {
      this.setState((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.state), {}, {
        localImage: event.target.files[0]
      }));
      var file = event.target.files[0];
      var type = file.type === "image/svg+xml" ? "svg" : file.type === "image/png" ? "png" : file.type === "image/jpg" ? "jpg" : file.type === "image/jpeg" ? "jpg" : null;
      var reader = new FileReader();
      if (type === "svg") {
        reader.readAsText(file, "UTF-8");
      } else if (type === "png" || type === "jpg") {
        reader.readAsDataURL(file);
      } else {
        alert("Couldn't read file type: " + file.type);
      }
      var that = this;
      reader.onload = function (readerEvent) {
        var content = readerEvent.target.result; // this is the content!

        that.setState({
          image: content,
          name: file.name.split(".").slice(0, -1).join("."),
          imageId: ++that.id,
          imageFormat: type,
          rotationCenterX: 500,
          rotationCenterY: 100
        });
      };
    }
  }, {
    key: "exportSVGAsync",
    value: function () {
      var _exportSVGAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  try {
                    var workspaceMask;
                    if (_paper.default.project.activeLayer.clipped) {
                      var _iterator = (0, _createForOfIteratorHelper2.default)(_paper.default.project.activeLayer.children),
                        _step;
                      try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                          var child = _step.value;
                          if (child.isClipMask()) {
                            workspaceMask = child;
                            break;
                          }
                        }
                      } catch (err) {
                        _iterator.e(err);
                      } finally {
                        _iterator.f();
                      }
                      _paper.default.project.activeLayer.clipped = false;
                      workspaceMask.remove();
                    }
                    var guideLayers = (0, _layer.hideGuideLayers)(true /* includeRaster */);

                    // Export at 0.5x
                    (0, _math.scaleWithStrokes)(_paper.default.project.activeLayer, 0.5, new _paper.default.Point());
                    var bounds = _paper.default.project.activeLayer.drawnBounds;
                    var centerX = bounds.width === 0 ? 0 : _view.SVG_ART_BOARD_WIDTH / 2 - bounds.x;
                    var centerY = bounds.height === 0 ? 0 : _view.SVG_ART_BOARD_HEIGHT / 2 - bounds.y;
                    var svgString = _paper.default.project.exportSVG({
                      asString: true,
                      bounds: "content",
                      matrix: new _paper.default.Matrix().translate(-bounds.x, -bounds.y),
                      compress: true,
                      dpi: 72
                    });
                    _this2.handleUpdateImage(true, svgString, centerX, centerY);
                    (0, _math.scaleWithStrokes)(_paper.default.project.activeLayer, 2, new _paper.default.Point());
                    _paper.default.project.activeLayer.applyMatrix = true;
                    (0, _layer.showGuideLayers)(guideLayers);
                    resolve(svgString);
                  } catch (error) {
                    reject(error);
                  }
                }));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function exportSVGAsync() {
        return _exportSVGAsync.apply(this, arguments);
      }
      return exportSVGAsync;
    }()
  }, {
    key: "delayForLoader",
    value: function () {
      var _delayForLoader = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(ms) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.props.showLoader();
                return _context2.abrupt("return", new Promise(function (resolve) {
                  return setTimeout(resolve, ms);
                }));
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function delayForLoader(_x) {
        return _delayForLoader.apply(this, arguments);
      }
      return delayForLoader;
    }()
  }, {
    key: "onSave",
    value: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var svgString;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.delayForLoader(1000);
              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return this.exportSVGAsync();
              case 5:
                svgString = _context3.sent;
                this.props.handleSave({
                  image: svgString,
                  name: this.state.name
                });
                // this.downloadImage();
                _context3.next = 13;
                break;
              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                console.log("something went wrong with generating svg");
                this.props.handleSave({
                  image: this.state.image,
                  name: this.state.name
                });
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 9]]);
      }));
      function onSave() {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }()
  }, {
    key: "dataToFile",
    value: function dataToFile(data, mimeType, fileName) {
      var byteArray;
      if (mimeType === "text/plain" || mimeType === "application/xml") {
        byteArray = new Uint8Array(data.length);
        for (var i = 0; i < data.length; i++) {
          byteArray[i] = data.charCodeAt(i);
        }
      } else {
        var byteCharacters = atob(data);
        byteArray = new Uint8Array(byteCharacters.length);
        for (var _i = 0; _i < byteCharacters.length; _i++) {
          byteArray[_i] = byteCharacters.charCodeAt(_i);
        }
      }
      return new File([byteArray], fileName, {
        type: mimeType
      });
    }
  }, {
    key: "handleSubmitToAiTool",
    value: function () {
      var _handleSubmitToAiTool = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var that, svgString;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.delayForLoader(1000);
              case 2:
                that = this;
                _context4.prev = 3;
                _context4.next = 6;
                return this.exportSVGAsync();
              case 6:
                svgString = _context4.sent;
                this.props.handleSubmitToAiTool(svgString);
                // fetch("https://dev.slashq.io/api/web/detect-seats-image-data", {
                //   method: "POST",
                //   body: JSON.stringify({
                //     image: svgString,
                //     type: "svg",
                //   }),
                //   headers: {
                //     "Content-type": "application/json; charset=UTF-8",
                //   },
                // })
                //   .then((response) => response.json())
                //   .then((responseJSON) => {
                //     //IF AI service throw error reset image to exported image
                //     if (responseJSON.status === "failure") {
                //       this.props.sendAlert(responseJSON.message);
                //       that.setState({
                //         ...that.state,
                //         image: svgString,
                //         imageFormat: "svg",
                //         rotationCenterX: 500,
                //         rotationCenterY: 100,
                //       });
                //       this.props.hideLoader();
                //     } else {
                //       that.setState({
                //         ...that.state,
                //         image: responseJSON.data.image,
                //         imageFormat: "svg",
                //         rotationCenterX: 500,
                //         rotationCenterY: 100,
                //         showDetectSeatButton: false,
                //       });
                //       this.props.hideLoader();
                //     }
                //   })
                //   .catch((error) => {
                //     console.log(error);
                //   });
                _context4.next = 14;
                break;
              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);
                console.log("something went wrong with generating svg");
                this.props.hideLoader();
              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));
      function handleSubmitToAiTool() {
        return _handleSubmitToAiTool.apply(this, arguments);
      }
      return handleSubmitToAiTool;
    }()
  }, {
    key: "downloadImage",
    value: function downloadImage() {
      var downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      var format = this.state.imageFormat;
      var data = this.state.image;
      if (format === "png" || format === "jpg") {
        data = this.b64toByteArray(data);
      } else {
        data = [data];
      }
      var blob = new Blob(data, {
        type: format
      });
      var filename = "".concat(this.state.name, ".").concat(format);
      var file = new File([blob], filename);
      if ("download" in HTMLAnchorElement.prototype) {
        var url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.type = blob.type;
        downloadLink.click();
        window.URL.revokeObjectURL(url);
      } else {
        // iOS Safari, open a new page and set href to data-uri
        var popup = window.open("", "_blank");
        var reader = new FileReader();
        reader.onloadend = function () {
          popup.location.href = reader.result;
          popup = null;
        };
        reader.readAsDataURL(blob);
      }
      document.body.removeChild(downloadLink);
    }
  }, {
    key: "b64toByteArray",
    value: function b64toByteArray(b64Data) {
      var sliceSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;
      // Remove header
      b64Data = b64Data.substring(b64Data.indexOf("base64,") + 7);
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return byteArrays;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react.default.createElement(_intl.IntlProvider, null, /*#__PURE__*/_react.default.createElement("div", {
        className: _wrapperModule.default.wrapper
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _wrapperModule.default.playgroundContainer
      }, /*#__PURE__*/_react.default.createElement(_paintEditor.default, Object.assign({
        hideLoader: this.props.hideLoader,
        showDetectSeatButton: this.props.showDetectSeatButton,
        showLoader: this.props.showLoader,
        handleSubmitToAiTool: this.handleSubmitToAiTool,
        seatIds: this.props.seatIds,
        multiSelectAttributes: this.props.multiSelectAttributes,
        sendAlertMessage: this.handleAlertMessage,
        onBackButton: this.handleBack,
        onSave: this.onSave
      }, this.state, {
        onUpdateName: this.handleUpdateName,
        onUpdateImage: this.handleUpdateImage,
        create: this.props.create
      }))))));
    }
  }]);
  return SVGEditor;
}(_react.default.Component);
exports.default = SVGEditor;